import { Component, Input } from '@angular/core';
import { PartnerProfileComponent } from 'app/partner';
import { XpressUserRoleEnum } from 'app/models';

@Component({
    selector: 'partner-profile-info-tab',
    templateUrl: './partner-profile-info-tab.component.html',
    styleUrls: [
        './partner-profile-info-tab.component.scss',
        '../partner-profile.component.scss'
    ]
})
export class PartnerProfileInfoTabComponent {
    public xpressUserRoleEnum = XpressUserRoleEnum;

    @Input()
    public parent!: PartnerProfileComponent;
}
